import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { InputStateToken } from "@voltmoney/schema";
import { api } from "../../../configs/api";
import SharedPropsService from "../../../SharedPropsService";
import { getAppHeader } from "../../../configs/config";
let counter = 0;
export const CreateDisbursementRequest = async (action, _datastore, { network, navigate, setDatastore, showPopup, instrumentTrack }) => {
    instrumentTrack('WITHDRAW_CONFIRM_BUTTON_CLICKED');
    const disbursalAmount = action.payload.disbursalAmount;
    await setDatastore(ROUTE.CONFIRM_AMOUNT, 'confirmAmountScreen', {
        loading: true,
        otpModal: false,
        counter: counter++,
    });
    const response = await network.post(api.lmsDisbursalV2, {
        creditId: (await SharedPropsService.getUser()).linkedCredits[0].creditId,
        disbursalAmount: disbursalAmount,
    }, { headers: await getAppHeader() });
    if (response?.status === 200) {
        const noOfOtpDigits = response?.data?.noOfDigits;
        await setDatastore(ROUTE.CONFIRM_AMOUNT, 'confirmAmountScreen', {
            loading: false,
            otpModal: true,
        });
    }
    if (response?.response?.status === 400) {
        if (response?.response?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP') {
            const errorMessage = response?.response?.data?.message;
            await setDatastore(ROUTE.CONFIRM_AMOUNT, 'confirmAmountScreen', {
                loading: false,
                otpModal: false,
            });
            showPopup({
                title: errorMessage,
                type: 'FAILED',
                ctaLabel: 'Go back',
                subTitle: ' ',
                ctaAction: {
                    routeId: ROUTE.ALERT_PAGE,
                    type: ACTION.CLOSE_POPUP,
                    payload: {}
                },
                primary: true
            });
        }
    }
    await setDatastore(ROUTE.CONFIRM_AMOUNT, 'confirmAmountScreen', {
        loading: false,
    });
};
export const disbursalVerifyAction = async (action, _datastore, { navigate, network, setDatastore, goBack, instrumentTrack }) => {
    const noOfOtpDigits = action?.payload?.noOfOtpDigits;
    const isFirstJourney = action?.payload?.isFirstJourney;
    if (`${action.payload.value}`.length > (noOfOtpDigits - 1)) {
        await setDatastore(ROUTE.CONFIRM_AMOUNT, "confirmAmountScreen", {
            state: InputStateToken.LOADING,
        });
        const response = await network.post(api.lmsDisbursalVerify, {
            otp: action.payload.value,
            phoneNo: (await SharedPropsService.getUser()).linkedBorrowerAccounts[0].accountHolderPhoneNumber,
        }, { headers: await getAppHeader() }, async () => {
            await setDatastore(ROUTE.CONFIRM_AMOUNT, "confirmAmountScreen", {
                state: InputStateToken.DEFAULT,
            });
        });
        if (response.status === 200) {
            const disbursalCreatedOn = response?.data.createdOn;
            await setDatastore(ROUTE.CONFIRM_AMOUNT, "confirmAmountScreen", {
                state: InputStateToken.SUCCESS,
                otpModal: false,
            });
            const user = await SharedPropsService.getUser();
            const creditId = user?.linkedCredits[0]?.creditId;
            const result = await network.get(`${api.getPendingCreditRequest}${creditId}`, {
                headers: await getAppHeader(),
            });
            const res = result?.data?.disbursalDetailsList[0];
            await navigate(ROUTE.WITHDRAW_REQUEST, { res, disbursalCreatedOn, isFirstJourney, verifyOTPResponse: response?.data });
        }
        else {
            if (response?.response?.status === 400) {
                if (response?.response?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP') {
                    await setDatastore(ROUTE.CONFIRM_AMOUNT, "confirmAmountScreen", {
                        state: InputStateToken.DISABLED,
                        caption: { error: response?.response?.data?.message },
                        otpLimitExceeded: true
                    });
                }
                else {
                    await setDatastore(ROUTE.CONFIRM_AMOUNT, "confirmAmountScreen", {
                        state: InputStateToken.ERROR,
                        caption: { error: response?.response?.data?.message }
                    });
                }
            }
            else {
                await setDatastore(ROUTE.CONFIRM_AMOUNT, "confirmAmountScreen", {
                    state: InputStateToken.ERROR,
                    caption: { error: response?.response?.data?.message }
                });
            }
        }
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goBack = async (action, _datastore, { goBack, navigate }) => {
    await goBack();
};
export const navigateToTransaction = async (action, _datastore, { goBack, navigate }) => {
    await navigate(ROUTE.TRANSACTIONS);
};
export const closeOtpModal = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.CONFIRM_AMOUNT, 'confirmAmountScreen', {
        loading: false,
        otpModal: false,
    });
};
